const NS = 'MarketOfferingTableBlock';
const CLS = 'marketOfferingTableBlock';

import { TableBlock } from '../../tableBlock/js/tableBlock';

export class MarketOfferingTableBlock extends TableBlock {
	constructor(element) {
		super(element, CLS);

		this.api = this.$element.attr('data-api');

		this.getTableDataFromApi();
	}

	setTableData() {
		this.columnDefs = [
			{
				headerName: 'Key',
				field: 'key',
				cellStyle: {
					'font-weight': 500
				},
				minWidth: 145,
				lockPosition: true
			},
			{
				headerName: 'Value',
				field: 'value',
				cellRenderer: (params) => {
					let numberFormatter = params.context.numberFormatter;

					if(params.data.key === 'Bales Offered' ||
						params.data.key === 'Bales Sold' ||
						params.data.key === 'Season Sold') {
						return `<span class="cell-value">${numberFormatter.formatNumbersWithCommas(params.value)}</span>`;
					}
					return `<span class="cell-value">${params.value}</span>`;
				},
				minWidth: 145,
				lockPosition: true
			}
		];
	}

	setGridOptions() {
		super.setGridOptions({
			headerHeight: 0
		});
	}


	getTableDataFromApi() {
		let url = this.api;

		if(!_.isEmpty(this.urlParams)) {
			url += `?${$.param(this.urlParams)}`;
		}

		if(this.api) {
			$.ajax({
				type: 'GET',
				url: url,
				dataType: 'json',
				success: (response) => {
					if(response && response.length > 0) {
						this.$element.trigger(`${CLS}.update`, {
							data: response
						});
					}
					else {
						this.$element.trigger(`${CLS}.update`, {
							data: null,
							isEmpty: true
						});
					}
				},
				error: () => {
					this.$element.trigger(`${CLS}.update`, {
						data: null,
						isError: true
					});
				}
			});
		}
		else {
			console.error(`${NS}::Error`, 'API is not set.');
			this.$element.trigger(`${CLS}.update`, {
				data: null
			});
		}
	}
}
